module.exports = __webpack_public_path__ + "static/media/n-particip.8d41aad4.svg";